import { useState, useEffect, useCallback, useRef } from "react";
import {
  useParams,
  NavLink,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import TabManager from "../Tabs/TabManager";
import TabContent from "./../Tabs/TabContent";
import { useLanguageContext } from "./../../Context/LanguageContext";
import {
  useEqDetailsTabActionContext,
  useEqDetailsTabContext,
} from "./../../Context/GlobalContext";
import { useGlobalSpinnerActionsContext } from "./../../Context/GlobalSpinnerContext";

import equipmentGroupConstants from "./../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "./../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "./../../Stores/EquipmentGroupStore";
import { useChildInfoContext } from "./../../Context/GlobalContext";
import { useChildInfoActionContext } from "./../../Context/GlobalContext";
import { useSelectedFunActionContext } from "./../../Context/GlobalContext";
import { toast } from "react-toastify";
function EquipmentDetails() {
  let {
    fonctionid,
    fonctionsname,
    equipmentGroup,
    equipmentId,
    inventarnr,
    bezeichnung,
    parentequipmentId,
    parentinventarnr,
    parentbezeichnung,
    id,
  } = useParams();
  const tabSelected = useEqDetailsTabContext();
  const { language } = useLanguageContext();
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const updateChildInfo = useChildInfoActionContext();
  const childObject = useChildInfoContext();
  const setTabSelected = useEqDetailsTabActionContext();
  const isMountedRef = useRef(null);
  const updateSelectedFunc = useSelectedFunActionContext();
  const [activeTab, setTab] = useState(null);
  const [data, setData] = useState(null);
  const [responseMessage, setResponseMessage] = useState(null);
  const [rederLink, setRenderLink] = useState("");
  const [isFunctionCall, setIsFunctionCall] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const fetchData = useCallback(() => {
    var _selectedAnlagegruppe = sessionStorage.getItem("eqGId");
    if (_selectedAnlagegruppe !== null && _selectedAnlagegruppe !== undefined) {
      setGlobalSpinner(true);
      equipmentGroupActions.getTabs(_selectedAnlagegruppe, language);
    }
  }, [language]);

  const handleSetTab = (id) => {
    setTab(id);
  };

  useEffect(() => {
    if (tabSelected?.id && data) {
      const _index = data.findIndex((item) => item.id === tabSelected.id);
      handleSetTab(
        tabSelected._key === "next" ? data[_index + 1].id : data[_index - 1].id,
      );
    }
  }, [tabSelected, data]);
  const createEquipentObj = (hasParent) => {
    let childInfo = [];
    if (hasParent) {
      childInfo = [
        {
          equipId: parentequipmentId,
          inventarnr: parentinventarnr,
          bezeichnung: parentbezeichnung,
        },
        {
          equipId: equipmentId,
          inventarnr: inventarnr,
          bezeichnung: bezeichnung,
        },
      ];
    } else {
      childInfo = [
        {
          equipId: equipmentId,
          inventarnr: inventarnr,
          bezeichnung: bezeichnung,
        },
      ];
    }
    return childInfo;
  };

  useEffect(() => {
    let childInfo;
    setIsFunctionCall(fonctionid === undefined ? false : true);
    if (fonctionid === undefined) {
      updateSelectedFunc(null);
      childInfo = createEquipentObj(
        parentequipmentId === undefined ? false : true,
      );
    } else {
      updateSelectedFunc(fonctionid, fonctionsname);
      childInfo = createEquipentObj(
        parentequipmentId === undefined ? false : true,
      );
      childInfo.unshift({
        funcId: fonctionid,
        funcName: fonctionsname,
      });
    }
    updateChildInfo(
      childInfo,
      fonctionid === undefined ? "Equipment" : "Function_Call",
    );
  }, [equipmentId]);

  useEffect(() => {
    if (childObject.length > 0) {
      const RenderParentChild = (
        <>
          <ul className="d-flex listStyle p-0">
            {childObject.map((item, i) => {
              if (i !== childObject.length - 1) {
                return (
                  <li key={i}>
                    /
                    <Link
                      to=""
                      onClick={(e) => {
                        handleChildClick(e, item);
                      }}
                    >
                      {item.funcName === undefined
                        ? item.bezeichnung === "" ||
                          item.bezeichnung === "null" ||
                          item.bezeichnung === "undefined"
                          ? item.inventarnr
                          : item.inventarnr + "-" + item.bezeichnung
                        : item.funcName === ""
                          ? fonctionsname
                          : item.funcName}
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li key={i}>
                    {" " +
                      " / " +
                      item.inventarnr +
                      `${
                        item.bezeichnung === "undefined" ||
                        item.bezeichnung === "" ||
                        item.bezeichnung === "null" ||
                        item.bezeichnung === "-"
                          ? ""
                          : " - " + item.bezeichnung
                      }`}
                  </li>
                );
              }
            })}
          </ul>
        </>
      );
      setRenderLink(RenderParentChild);
    }
  }, [childObject]);

  useEffect(() => {
    isMountedRef.current = true;

    if (isMountedRef.current) {
      fetchData();
    }

    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    function updateData() {
      var tmp = equipmentGroupStore.getTabs();
      if (isMountedRef.current) {
        setData(tmp);
        if (tmp !== null && tmp !== undefined && tmp.length > 0) {
          if (tmp[0] === null) {
            toast.error(localization.noMenuItemSetUpError);
          } else {
            var selectedTabId_default =
              sessionStorage.getItem("tabid") !== null &&
              sessionStorage.getItem("tabid") !== undefined
                ? sessionStorage.getItem("tabid")
                : tmp[0].id;
            handleSetTab(selectedTabId_default);
            setTabSelected({
              id: null,
              _key: "",
              tabDetails: tmp,
            });
          }
        } else {
          toast.error(localization.noMenuItemSetUpError);
        }

        setGlobalSpinner(false);
      }
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_TABSMENU_SUCCESS,
      updateData,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_TABSMENU_SUCCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setData(null);
      setResponseMessage(localization.tabsError);
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_TABSMENU_FAILURE,
      updateData,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_TABSMENU_FAILURE,
        updateData,
      );
    };
  }, []);

  function handleChildClick(e, row) {
    e.preventDefault();
    const _pathRoot = renderRootPath();
    let path = "";
    const rowbez =
      row.bezeichnung !== null &&
      row.bezeichnung !== undefined &&
      row.bezeichnung.length != 0
        ? row.bezeichnung
        : "-";
    sessionStorage.setItem("eqId", row.equipId);
    sessionStorage.setItem("invnr", row.inventarNr);
    if (row.funcId) {
      path =
        _pathRoot +
        sessionStorage.getItem("eqBez") +
        "/" +
        row.funcId +
        "/" +
        row.funcName;
    } else {
      if (fonctionid) {
        path =
          _pathRoot +
          "/" +
          sessionStorage.getItem("eqBez") +
          "/" +
          fonctionid +
          "/" +
          fonctionsname +
          "/" +
          row.equipId +
          "/" +
          rowbez +
          "/" +
          row.inventarnr;
      } else {
        path =
          _pathRoot +
          "/" +
          sessionStorage.getItem("eqBez") +
          "/" +
          row.equipId +
          "/" +
          rowbez +
          "/" +
          row.inventarnr;
      }
    }

    navigate(path);
  }
  function renderRootPath() {
    const _parentPath = location.pathname.startsWith("/equipmentGrpEqiupment")
      ? "/equipmentGrpEqiupment"
      : "/inspection";
    return _parentPath;
  }
  return data !== null && data !== undefined ? (
    <div id="content">
      <h2 className="sub-header d-flex">
        {sessionStorage.getItem("plant") + "/"}
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to={renderRootPath()}
        >
          {sessionStorage.getItem("eqBez")}
        </NavLink>
        {rederLink}
      </h2>

      <TabManager
        tabs={data}
        activeTab={activeTab}
        handleSelectTab={handleSetTab}
        tabPageName="EquipmentDetailOverview"
      />

      <TabContent
        tabid={activeTab}
        tabs={data}
        anlageid={equipmentId}
        handleTabSelection={handleSetTab}
        isFunctionCall={isFunctionCall}
      />
    </div>
  ) : null;
}
export default EquipmentDetails;
